// extracted by mini-css-extract-plugin
module.exports = {"heading":"headings_heading__n29C1","inner":"headings_inner__xHKjy","line":"headings_line__RM8my","active":"headings_active__ROJ8F"};